module.exports = { src: __webpack_public_path__ + "media/hot.1e371848.svg", width: 229, height: 218 };